import { createImageElement } from '@/utils/elements';

import { CROSS_ORIGIN, MIME } from '@/constants/photos';

export default class OffscreenCanvas {
  constructor(width, height) {
    this.canvas = document.createElement('canvas');
    this.canvas.width = width;
    this.canvas.height = height;
    this.canvas.getBlob = this.getBlob.bind(this);
    this.canvas.getImage = this.getImage.bind(this);
    return this.canvas;
  }

  getBlob(type = MIME.PNG, quality) {
    const canvas = this.canvas;
    return new Promise(function executor(resolve) {
      canvas.toBlob(resolve, type, quality);
    });
  }

  getImage(type = MIME.PNG, quality) {
    function onBlob(blob) {
      return createImageElement({ crossOrigin: CROSS_ORIGIN.ANONYMOUS, src: URL.createObjectURL(blob) });
    }

    return this.getBlob(type, quality).then(onBlob);
  }
}
